module.exports = __webpack_public_path__ + "static/img/hb_14-min.74a6bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_14-min.png
// module id = 9yMP
// module chunks = 1